import { useEffect } from "react";
import Lenis from "lenis";
import { useA11y } from "@/context/A11yContext";

export const SmoothScroll = () => {
  const { settings } = useA11y();
  useEffect(() => {
    if (settings.reduceMotion) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [settings.reduceMotion]);
  return null;
};
